export class PresseMessages {

  public content_create ='presse.content_create'
  public content_update ='presse.content_update'
  public confirmer ='presse.confirmer'
  public retour ='presse.retour'
  public supprimer ='presse.supprimer'
  public intitule ='presse.intitule'
  public email ='presse.email'
  public contact ='presse.contact'
  public telephone ='presse.telephone'
  public departement ='presse.departement'
  public modal_delete_text = 'presse.modal_delete_text'
  public modal_create_text = 'presse.modal_create_text'
  public modal_update_text = 'presse.modal_update_text'

  constructor() {
  }
}
